import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { VerifyOtpPayload } from "./dto";
import { recruiterClient } from "config/axios";
import PATHS from "config/paths";

export const passwordOtpVerify = (data: VerifyOtpPayload): Promise<{}> => {
  return recruiterClient.httpClient.post(PATHS.recruiter.changePassword.verifyOtp, data);
};

export const useRecruiterPasswordOtpVerify = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async ({ data, token }: any, __, ___) => {
      await queryClient.invalidateQueries();
      notification.success({
        message: "Verified",
        description: "Otp successfully verified",
      });
    },

    mutationFn: passwordOtpVerify,
  });
};
